/** @jsx jsx */
import React from 'react'
import PropTypes from 'prop-types'
import { css, jsx } from '@emotion/react'

import currencyFormat from 'functions/currencyFormat'
import styles from './styles.scss'

const QuoteItem = (props) => {
  const {
    campaignQuoteItem: {
      display_title, hidden, price_override, row_title,
    },
    customCSS,
    showPrice,
  } = props

  const customItemCss = customCSS.quoteItem

  if (hidden){
    return null
  }

  return (
    <li
      className={styles.root}
      css={
        customItemCss
          ? css`
              ${customItemCss}
            `
          : null
      }
    >
      <span className={styles.left} data-id="item-left">
        {row_title && (
          <span className={styles.rowTitle} data-id="item-row-title">
            {row_title}
          </span>
        )}
        <span data-id="item-title">{display_title}</span>
      </span>

      {showPrice && (
        <span className={styles.right} data-id="item-price">
          {currencyFormat(price_override)}
        </span>
      )}
    </li>
  )
}

QuoteItem.propTypes = {
  campaignQuoteItem: PropTypes.object.isRequired,
  customCSS: PropTypes.object.isRequired,
  showPrice: PropTypes.bool,
}

export default QuoteItem
